import EventIcon from "@mui/icons-material/Event";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";

// Booking status colors for all booking types
export const STATUS_COLORS = {
  Scheduled: "#6366f1", // primary indigo
  Confirmed: "#22c55e",
  Ongoing: "#f97316",
  Completed: "#22c55e",
  Cancelled: "#ef4444",
};

export const DURATIONS = [30, 45, 60, 90, 120];

export const STATUS_META = {
  Scheduled: {
    icon: EventIcon,
    color: "#6366f1",
  },
  Confirmed: {
    icon: CheckCircleIcon,
    color: "#22c55e",
  },
  Ongoing: {
    icon: PlayCircleIcon,
    color: "#f97316",
  },
  Completed: {
    icon: CheckCircleIcon,
    color: "#22c55e",
  },
  Cancelled: {
    icon: CancelIcon,
    color: "#ef4444",
  },
};
